import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router,NavigationEnd } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { LoginServiceService } from 'src/app/services/api/login-service.service';
import { AuthService } from 'src/app/services/auth.service';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';


@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss']
})
export class LoginViewComponent implements OnInit {
  @ViewChild(SnackbarComponent) Snack;
  constructor(private router: Router,private _loginService : LoginServiceService,private _authservice : AuthService,private _SnackService : SnackBarService,
    private activatedRoute: ActivatedRoute) { }

  username: string;
  password: string;
  Checked : boolean = false;
  RememberMe : boolean = false;
  RouteForget : boolean = false;
  errorMessage = '';
  passwordType = 'password';

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    RememberMe : new FormControl('', [Validators.required]),
  });
  @Output() newItemEvent = new EventEmitter<boolean>();

  ngOnInit( ): void {
    this.activatedRoute.url.subscribe((res) => {
      console.log(res[0].path);
    })
    if (localStorage.getItem('token')) {
      this._authservice.isUserLoggedIn.next(true);
    }
    else
     { this._authservice.isUserLoggedIn.next(false);
    }
    if(localStorage.getItem('token') == null){
      this.router.navigate(['./login'])
    }
    else{
      this.router.navigate(['./invoicing/carrier'])

    }

  }

  login(e) {

   // this.router.navigate(['./invoicing/carrier']);
    this.newItemEvent.emit(true);

    this._authservice.loginAuthenticate(e).subscribe((res) => {
        console.log(res);
        if(!res.IsFirstTimeLogin){
          this._loginService.settoggleview(true);
          localStorage.setItem('Role',res.Role);
          this._SnackService.CloseProgressSpinner(true);
          this.router.navigate(['./invoicing/carrier']);
        }
        else{

          this.router.navigate(['./resetpassword'],{ queryParams: { token: res.token,username:res.username}} );

        }

},
(err) => {
  console.log(err);
  this._SnackService.setSnackMessage(err);
  this.errorMessage = "Invalid Credentials,Please try again"
  //this.Snack.message = err.message;
  this._SnackService.CloseProgressSpinner(true);
  this._SnackService.notification$.next('this is a notification');

})
  }

  ForgetPassword() {
     this.router.navigate(['./forgetpassword']);
    // this.router.navigateByUrl('/forgetpassword');

console.log(this.router.url);
  }

  setPasswordType(): void {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }




  }


